import { useState, useEffect } from "react";
import API from "../services/api";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default function QRGenerator() {

  const [category, setCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [quantity, setQuantity] = useState(1);
  const [note, setNote] = useState("");

  // ==========================
  // QR PREVIEW
  // ==========================
  const [qrList, setQrList] = useState([]);

  // ==========================
  // QR HISTORY
  // ==========================
  const [history, setHistory] = useState([]);

  // ==========================
  // LOADING
  // ==========================
  const [loading, setLoading] = useState(false);

  // ==========================
  // ZIP DOWNLOAD
  // ==========================
  const [downloadUrl, setDownloadUrl] = useState("");

  // ==========================
  // LOAD DATA
  // ==========================
  useEffect(() => {

    loadCategories();

    loadHistory();

  }, []);

  // ==========================
  // LOAD CATEGORIES
  // ==========================
  const loadCategories = async () => {

    try {

      const res = await API.get("/categories");

      setCategories(res.data || []);

    } catch (err) {

      console.log(
        "Category Load Error:",
        err
      );
    }
  };

  // ==========================
  // LOAD QR HISTORY
  // ==========================
  const loadHistory = async () => {

    try {

      const res =
        await API.get("/qr/history");

      setHistory(res.data || []);

    } catch (err) {

      console.log(
        "QR History Error:",
        err
      );
    }
  };

  // ==========================
  // GENERATE QR
  // ==========================
  const generate = async () => {

    try {

      if (!category || !quantity) {

        return alert(
          "Select category & quantity"
        );
      }

      setLoading(true);

      // clear old data
      setQrList([]);

      setDownloadUrl("");

      const res =
        await API.post(
          "/qr/generate-qr",
          {
            category_id: category,
            quantity,
            note
          }
        );

      // ==========================
      // QR PREVIEW
      // ==========================
      setQrList(
        res.data.qrList || []
      );

      // ==========================
      // ZIP URL
      // ==========================
      setDownloadUrl(
        res.data.download_url || ""
      );

      // reload history
      loadHistory();

      alert(
        "QR Generated Successfully"
      );

    } catch (err) {

      console.error(err);

      alert(
        err.response?.data?.msg ||
        "QR Generation Failed"
      );

    } finally {

      setLoading(false);
    }
  };

  // ==========================
  // DOWNLOAD PDF
  // ==========================
  const downloadPDF = async () => {

    try {

      const element =
        document.getElementById(
          "qr-print-area"
        );

      const canvas =
        await html2canvas(
          element,
          {
            scale: 2
          }
        );

      const imgData =
        canvas.toDataURL(
          "image/png"
        );

      const pdf =
        new jsPDF(
          "p",
          "mm",
          "a4"
        );

      const imgWidth = 210;

      const imgHeight =
        (canvas.height * imgWidth)
        / canvas.width;

      pdf.addImage(
        imgData,
        "PNG",
        0,
        0,
        imgWidth,
        imgHeight
      );

      pdf.save("QR-Codes.pdf");

    } catch (err) {

      console.error(err);

      alert(
        "PDF Download Failed"
      );
    }
  };

  return (

    <div className="dashboard-container">

      {/* ==========================
          PAGE TITLE
      ========================== */}
      <h2 className="dashboard-heading">
        QR Generator
      </h2>

      {/* ==========================
          FORM
      ========================== */}
      <div
        style={{
          display: "flex",
          gap: 10,
          marginBottom: 20,
          flexWrap: "wrap",
          alignItems: "center"
        }}
      >

        {/* CATEGORY */}
        <select
          value={category}
          onChange={(e) =>
            setCategory(
              e.target.value
            )
          }
          style={{
            padding: 10
          }}
        >

          <option value="">
            Select Category
          </option>

          {categories.map((c) => (

            <option
              key={c.id}
              value={c.id}
            >
              {c.category_name}
              {" "}
              (Rs {c.claim_amount})
            </option>

          ))}
        </select>

        {/* QUANTITY */}
        <input
          type="number"
          placeholder="Quantity"
          value={quantity}
          onChange={(e) =>
            setQuantity(
              e.target.value
            )
          }
          style={{
            padding: 10,
            width: 120
          }}
        />

        {/* MODEL */}
        <input
          placeholder="Model Number"
          value={note}
          onChange={(e) =>
            setNote(
              e.target.value
            )
          }
          style={{
            padding: 10,
            minWidth: 220
          }}
        />

        {/* GENERATE */}
        <button
          onClick={generate}
          disabled={loading}
          style={{
            background: "#1976d2",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            padding: "10px 20px",
            cursor: "pointer"
          }}
        >
          {loading
            ? "Generating..."
            : "Generate QR"}
        </button>

        {/* PDF DOWNLOAD */}
        {qrList.length > 0 && (

          <button
            onClick={downloadPDF}
            style={{
              background: "#333",
              color: "#fff",
              border: "none",
              borderRadius: 6,
              padding: "10px 20px",
              cursor: "pointer"
            }}
          >
            Download PDF
          </button>
        )}

        {/* ZIP DOWNLOAD */}
        {downloadUrl && (

          <button
            onClick={() =>
              window.open(
                downloadUrl,
                "_blank"
              )
            }
            style={{
              background: "green",
              color: "#fff",
              border: "none",
              borderRadius: 6,
              padding: "10px 20px",
              cursor: "pointer"
            }}
          >
            Download ZIP
          </button>
        )}
      </div>

      {/* ==========================
          CLAIM AMOUNT
      ========================== */}
      {category && (

        <p
          style={{
            fontWeight: "bold",
            marginBottom: 20
          }}
        >
          Claim Amount: Rs {

            categories.find(
              c => c.id == category
            )?.claim_amount || 0
          }
        </p>
      )}

      <hr />

      {/* ==========================
          QR PREVIEW
      ========================== */}
      <div
        id="qr-print-area"
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 20,
          background: "#fff",
          padding: 20
        }}
      >

        {qrList.map((q, i) => {

          const parts =
            q.value.split("-");

          const brand =
            parts[0];

          const serial =
            parts[parts.length - 1];

          const dd =
            parts[parts.length - 2];

          const mm =
            parts[parts.length - 3];

          const yy =
            parts[parts.length - 4];

          const categoryName =
            parts
              .slice(
                1,
                parts.length - 4
              )
              .join("-");

          const date =
            `${yy}-${mm}-${dd}`;

          return (

            <div
              key={i}
              style={{
                width: 180,
                border:
                  "1px solid #ccc",
                borderRadius: 10,
                padding: 10,
                textAlign: "center",
                background: "#fff",
                boxShadow:
                  "0 2px 6px rgba(0,0,0,0.1)"
              }}
            >

              {/* QR IMAGE */}
              <img
                src={q.image}
                width={140}
                alt="QR"
                style={{
                  marginBottom: 10
                }}
              />

              {/* COMPANY + CATEGORY */}
              <p
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  margin: 0,
                  lineHeight: 1.4
                }}
              >
                {brand}-{categoryName}
              </p>

              {/* SERIAL */}
              <p
                style={{
                  fontWeight: "bold",
                  fontSize: 16,
                  marginTop: 5,
                  marginBottom: 5,
                  letterSpacing: 1
                }}
              >
                {serial}
              </p>

              {/* DATE */}
              <p
                style={{
                  fontSize: 12,
                  margin: 0,
                  marginBottom: 6
                }}
              >
                Dtd: {date}
              </p>

              {/* MODEL */}
              <p
                style={{
                  fontSize: 13,
                  margin: 0,
                  lineHeight: 1.4
                }}
              >
                Model: {note || "-"}
              </p>

            </div>
          );
        })}
      </div>

      {/* ==========================
          QR HISTORY
      ========================== */}
      <div
        style={{
          marginTop: 40
        }}
      >

        <h3>
          QR Batch History
        </h3>

        <table
          style={{
            width: "100%",
            borderCollapse:
              "collapse",
            marginTop: 20
          }}
        >

          <thead>

            <tr
              style={{
                background: "#f5f5f5"
              }}
            >

              <th style={thStyle}>
                Batch
              </th>

              <th style={thStyle}>
                Category
              </th>

              <th style={thStyle}>
                Qty
              </th>

              <th style={thStyle}>
                Model
              </th>

              <th style={thStyle}>
                Date
              </th>

              <th style={thStyle}>
                Action
              </th>

            </tr>
          </thead>

          <tbody>

            {history.map((row) => (

              <tr key={row.id}>

                <td style={tdStyle}>
                  {row.id}
                </td>

                <td style={tdStyle}>
                  {row.category_name}
                </td>

                <td style={tdStyle}>
                  {row.quantity}
                </td>

                <td style={tdStyle}>
                  {row.note}
                </td>

                <td style={tdStyle}>
                  {
                    new Date(
                      row.created_at
                    )
                    .toLocaleDateString()
                  }
                </td>

                <td style={tdStyle}>

                  {row.zip_path ? (

                    <button
                      onClick={() =>
                        window.open(
                          row.zip_path,
                          "_blank"
                        )
                      }
                      style={{
                        background:
                          "green",
                        color: "#fff",
                        border: "none",
                        borderRadius: 6,
                        padding:
                          "8px 14px",
                        cursor:
                          "pointer"
                      }}
                    >
                      Reprint ZIP
                    </button>

                  ) : (

                    <span>
                      No ZIP
                    </span>
                  )}

                </td>

              </tr>
            ))}

          </tbody>
        </table>
      </div>

    </div>
  );
}

// ==========================
// TABLE STYLES
// ==========================
const thStyle = {
  border: "1px solid #ddd",
  padding: 12,
  textAlign: "left"
};

const tdStyle = {
  border: "1px solid #ddd",
  padding: 12
};